import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LanguageSwitch } from "@/components/LanguageSwitch";
import { Wordmark } from "@/components/Wordmark";
import { useLocale } from "@/locale/LocaleContext";
import shell from "@/components/shell.module.css";

export function PrivacyPage() {
  const { m } = useLocale();
  return (
    <LegalShell title={m.legal.privacyTitle}>
      <p>{m.legal.privacyP1}</p>
      <p>{m.legal.privacyP2}</p>
      <p>{m.legal.privacyP3}</p>
    </LegalShell>
  );
}

export function TermsPage() {
  const { m } = useLocale();
  return (
    <LegalShell title={m.legal.termsTitle}>
      <p>{m.legal.termsP1}</p>
      <p>{m.legal.termsP2}</p>
      <p>{m.legal.termsP3}</p>
      <p>{m.legal.termsP4}</p>
      <p>{m.legal.termsP5}</p>
    </LegalShell>
  );
}

function LegalShell({ title, children }: { title: string; children: ReactNode }) {
  const { m } = useLocale();
  return (
    <div className="app-frame fade-in">
      <header className={shell.top}>
        <Wordmark />
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <LanguageSwitch />
          <Link to="/">{m.common.toSite}</Link>
        </div>
      </header>
      <main id="main" className={shell.main} style={{ maxWidth: 40 * 16 }}>
        <h1 className={shell.pageTitle}>{title}</h1>
        <div style={{ display: "grid", gap: "0.85rem", color: "var(--color-ink-secondary)" }}>{children}</div>
      </main>
      <footer className={shell.footerPublic}>
        <Link to="/privacy">{m.common.privacy}</Link>
        <Link to="/terms">{m.common.terms}</Link>
      </footer>
    </div>
  );
}
